/**
 * Stable identifiers for table pages. Must match pageKey sent to the API.
 */
export const TABLE_PAGE_KEYS = {
  SHIPMENT_LIST: "shipment-list",
  DROP_TRAILERS: "drop-trailers",
  PARTIAL_SHIPMENTS: "partial-shipments",
  ORDERS_INCOMING: "orders-incoming",
  LOCATIONS: "locations-table",
  INVOICE_MY: "my-invoices",
  INVOICE_DRAFTS: "invoice-drafts",
  INVOICE_REJECTED: "rejected-invoices",
  INVOICE_CHARGES_AUDIT: "charges-audit",
  TEAM_MEMBERS: "team-table",
  TEAM_PREFERRED_PARTNERS: "preferred-partners",
  TEAM_ORG_INVITES: "org-invites",
  TEAM_LOCATIONS: "team-location-management",
  TEAM_CHILD_ORGS: "add-child-organization",
  CONTRACTS: "contracts-details",
  CONTRACT_LANES: "contract-lanes",
  CONTRACT_RATES: "contract-rates",
  CONTRACT_ROUTES: "contract-routes",
  INVENTORY: "inventory-table",
  DOCUMENTS: "document-table",
  NOTIFICATION_SHIPMENT: "notification-shipment",
  NOTIFICATION_INVOICE: "notification-invoice",
  MESSAGES_MY: "messages-my",
  MESSAGES_CUSTOMER: "messages-customer",
};
